// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================== */
/*           Toast          */
/* ======================== */
.error-toast-button{
    color: rgb(255,102,152);
    border-color: rgb(255,102,152);
    margin-top: 5px;
    margin-left: 113px;
  }
  .error-toast-button:hover{
    background-color: rgba(255, 102, 153, 0.596);
  }
  .toast-div-label{
    margin-top: -44px;
    margin-left: 45px;
  }
  .svg-icon{
    height: 40px;
  }
  .Toastify__toast--default{
    border-left-width: 10px;
    border-left-color:   rgb(255,102,152);
    border-left-style: solid; 
  }
  
  .Toastify__progress-bar-theme--light{
    background: rgb(255,102,152);
  }
  .toast-message{
    margin-left: 25px;
    font-family: 'Calibre' ;
    width: 210px;
  }
  
  .Toastify__toast--success{
    border-left-width: 10px;
    border-left-color:  rgb(204,255,153);
    border-left-style: solid;
    animation-duration: 5000;
    
  }
  .Toastify__toast--error{
    border-left-width: 10px;
    border-left-color:   rgb(255,102,152);
    border-left-style: solid;
  }
  .Toastify__toast--warning{
    border-left-width: 10px;
    border-left-color:   rgb(214,150,3);
    border-left-style: solid;
  }
  .Toastify__toast--info{
    border-left-width: 10px;
    border-left-color: rgb(0, 24, 92);
    border-left-style: solid;
  }
  .Toastify__progress-bar--success {
    background: rgb(204,255,153);
  }
  
  .Toastify__progress-bar--info {
    background: rgb(0, 24, 92);
  }
  .Toastify__progress-bar--warning {
    background: rgb(214,150,3);
  }
  .Toastify__progress-bar--error {
    background:  rgb(255,102,152);
  }`, "",{"version":3,"sources":["webpack://./src/components/toasts/Toast.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,qCAAqC;IACrC,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,oCAAoC;IACpC,wBAAwB;IACxB,wBAAwB;;EAE1B;EACA;IACE,uBAAuB;IACvB,qCAAqC;IACrC,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,mCAAmC;IACnC,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,iCAAiC;IACjC,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B","sourcesContent":["/* ======================== */\n/*           Toast          */\n/* ======================== */\n.error-toast-button{\n    color: rgb(255,102,152);\n    border-color: rgb(255,102,152);\n    margin-top: 5px;\n    margin-left: 113px;\n  }\n  .error-toast-button:hover{\n    background-color: rgba(255, 102, 153, 0.596);\n  }\n  .toast-div-label{\n    margin-top: -44px;\n    margin-left: 45px;\n  }\n  .svg-icon{\n    height: 40px;\n  }\n  .Toastify__toast--default{\n    border-left-width: 10px;\n    border-left-color:   rgb(255,102,152);\n    border-left-style: solid; \n  }\n  \n  .Toastify__progress-bar-theme--light{\n    background: rgb(255,102,152);\n  }\n  .toast-message{\n    margin-left: 25px;\n    font-family: 'Calibre' ;\n    width: 210px;\n  }\n  \n  .Toastify__toast--success{\n    border-left-width: 10px;\n    border-left-color:  rgb(204,255,153);\n    border-left-style: solid;\n    animation-duration: 5000;\n    \n  }\n  .Toastify__toast--error{\n    border-left-width: 10px;\n    border-left-color:   rgb(255,102,152);\n    border-left-style: solid;\n  }\n  .Toastify__toast--warning{\n    border-left-width: 10px;\n    border-left-color:   rgb(214,150,3);\n    border-left-style: solid;\n  }\n  .Toastify__toast--info{\n    border-left-width: 10px;\n    border-left-color: rgb(0, 24, 92);\n    border-left-style: solid;\n  }\n  .Toastify__progress-bar--success {\n    background: rgb(204,255,153);\n  }\n  \n  .Toastify__progress-bar--info {\n    background: rgb(0, 24, 92);\n  }\n  .Toastify__progress-bar--warning {\n    background: rgb(214,150,3);\n  }\n  .Toastify__progress-bar--error {\n    background:  rgb(255,102,152);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
